<template>
  <div class="user-edit">
    <CHeader :title="title"></CHeader>
    <CheckUser v-if="!hasUserInfo" />
    <v-container v-else fluid class="body">
      <template v-if="multiProfile && !hasProfile">
        <v-row>
          <v-col cols="12" class="pt-2 pb-0">
            <v-alert type="warning" class="mb-0" dense dismissible>
              您可能认领的档案
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0">
            <CUsers
              :items="profileList"
              :totalCount="totalCount"
              @setClaim="fnClaim"
            ></CUsers>
          </v-col>
        </v-row>
      </template>
      <v-row v-if="noProfile && !addProfile && !hasProfile">
        <v-col cols="12" class="py-6 px-6">
          <v-btn
            @click="$router.push('users')"
            color="grey lighten-2"
            class="mb-3"
            depressed
            block
          >
            再去找找看
          </v-btn>
          <v-btn @click="fnCreatProfile()" color="primary" block>
            <v-icon class="mr-1">mdi-account-plus</v-icon>
            我要新建档案
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="hasProfile || addProfile">
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-app-bar color="grey lighten-3" class="caption" flat>
              <v-btn
                @click="$router.go(-1)"
                color="grey darken-1"
                dark
                depressed
                small
              >
                <v-icon class="mr-1" small>mdi-chevron-left</v-icon>
                返回
              </v-btn>
              <v-spacer></v-spacer>
              <v-chip
                v-if="hasProfile && !currentProfile.checked"
                color="warning"
                class="mr-1"
                label
                small
              >
                档案待审核
              </v-chip>
              <v-sheet @click="$router.push('useredit')" color="transparent">
                {{ utils.setName(userInfo) }}
                <v-avatar size="36" class="ml-3">
                  <img
                    v-if="userInfo.avatarUrl"
                    :src="utils.checkFile(userInfo.avatarUrl)"
                  />
                  <v-icon v-else>mdi-account</v-icon>
                </v-avatar>
              </v-sheet>
            </v-app-bar>
          </v-col>
        </v-row>
        <v-row v-for="(item, index) in formDefault" :key="index">
          <v-col v-if="item.type == 'company'" cols="12" class="py-2 px-6">
            <v-icon class="mr-1">{{ item.icon }}</v-icon>
            {{ item.value }}
          </v-col>
          <v-col v-else-if="item.type == 'radios'" cols="12" class="py-2 px-6">
            <v-radio-group
              v-model="item.value"
              :label="item.label"
              :prepend-icon="item.icon"
              dense
              hide-details
              row
              class="mt-0"
            >
              <template v-for="(v, i) in item.values">
                <v-radio :key="i" :label="v" :value="v"></v-radio>
              </template>
            </v-radio-group>
          </v-col>
          <v-col
            v-else-if="item.type == 'chips' && item.values"
            cols="12"
            class="py-2 px-6"
          >
            <v-icon class="mr-1">{{ item.icon }}</v-icon>
            {{ item.label }}
            <v-chip v-if="item.multiple" label small>多选</v-chip>
            <v-chip-group
              v-model="item.value"
              active-class="primary"
              column
              :multiple="item.multiple"
            >
              <template v-for="(v, i) in item.values">
                <v-chip :key="i" :value="v" filter outlined label small>
                  {{ v }}
                </v-chip>
              </template>
            </v-chip-group>
          </v-col>
          <v-col
            v-else-if="item.type == 'textarea'"
            cols="12"
            class="py-2 px-6"
          >
            <v-textarea
              v-model="item.value"
              :label="item.label"
              :prepend-inner-icon="item.icon"
              :placeholder="item.placeholder"
              rows="3"
              row-height="15"
              dense
              hide-details
              clearable
              outlined
            ></v-textarea>
          </v-col>
          <v-col v-else cols="12" class="py-2 px-6">
            <v-text-field
              v-model="item.value"
              :label="item.label"
              :name="item.valueKey"
              :prepend-inner-icon="item.icon"
              :placeholder="item.placeholder"
              :clearable="!item.readonly"
              :readonly="item.readonly"
              :class="item.readonly ? 'grey lighten-2 dark' : ''"
              dense
              hide-details
              outlined
            >
              <template
                v-if="item.label == '机构' && item.appendIcon && hasProfile"
                v-slot:append
              >
                <v-icon
                  @click="fnEditOrg(currentProfile.channelId)"
                  color="primary"
                >
                  {{ item.appendIcon }}
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-2 pb-4 px-6">
            <v-btn
              v-if="hasProfile"
              @click="fnSetParams('edit')"
              color="primary"
              block
            >
              <v-icon class="mr-1">mdi-content-save</v-icon>
              保存
            </v-btn>
            <v-btn
              v-if="addProfile"
              @click="fnSetParams('add')"
              color="primary"
              block
            >
              <v-icon class="mr-1">mdi-content-save</v-icon>
              新增
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-container>
    <CNav :currentNav="2"></CNav>
    <CLoading
      v-model="loading"
      :text="tipsText"
      :timeout="timeout"
      @closeDialog="loading = false"
    />
    <CLoading v-model="tips" :text="tipsText" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

// 自定义功能
import config from "@/utils/config";
import utils from "@/utils/index";
// 自定义组件
import CheckUser from "@/components/global/check_user";
import CHeader from "@/components/c_header";
import CNav from "@/components/c_nav";
import CLoading from "@/components/c_loading";
import CUsers from "@/components/c_users";

export default {
  name: "UsersEdit",
  components: {
    CheckUser,
    CHeader,
    CNav,
    CLoading,
    CUsers,
  },
  data: () => ({
    utils: utils,
    title: null,
    alert: true,
    hasUserInfo: false,
    userInfo: null,
    hasProfile: false,
    currentProfile: {},
    multiProfile: false,
    noProfile: false,
    addProfile: false,
    totalCount: 0,
    profileList: [],
    channelId: null,
    contentId: null,
    confirm: false,
    tipsText: "请稍候...",
    loading: false,
    timeout: 3000,
    tips: null,
    tipColor: "primary",
    formDefault: [
      {
        type: "chips",
        label: "民族",
        icon: "mdi-account-supervisor",
        placeholder: "请输入民族",
        valueKey: "ethnicGroup",
        multiple: false,
        value: null,
        values: [],
      },
      {
        type: "chips",
        label: "政治面貌",
        icon: "mdi-account-star",
        placeholder: "请输入政治面貌",
        valueKey: "politics",
        multiple: false,
        value: null,
        values: [],
      },
      {
        type: "chips",
        label: "学历",
        icon: "mdi-book-education-outline",
        placeholder: "请输入学历",
        valueKey: "qualification",
        multiple: false,
        value: null,
        values: [],
      },
      {
        type: "chips",
        label: "学位",
        icon: "mdi-school",
        placeholder: "请输入学位",
        valueKey: "degree",
        multiple: false,
        value: null,
        values: [],
      },
      {
        type: "text",
        label: "毕业学校",
        icon: "mdi-card-account-details",
        placeholder: "请输入毕业学校",
        valueKey: "school",
        value: null,
      },
      {
        type: "chips",
        label: "专业技能",
        icon: "mdi-tag-multiple",
        placeholder: "请输入专业技能",
        valueKey: "profSkill",
        multiple: true,
        value: [],
        values: [],
      },
      {
        type: "chips",
        label: "专业职称",
        icon: "mdi-certificate",
        placeholder: "请输入专业职称",
        valueKey: "profTitle",
        multiple: true,
        value: [],
        values: [],
      },
      {
        type: "text",
        label: "机构",
        icon: "mdi-account-group",
        appendIcon: "mdi-file-edit-outline",
        placeholder: "请输入机构",
        valueKey: "channelName",
        value: null,
        readonly: true,
      },
      {
        type: "text",
        label: "部门",
        icon: "mdi-account-details",
        placeholder: "请输入部门",
        valueKey: "department",
        value: null,
      },
      {
        type: "text",
        label: "职务",
        icon: "mdi-card-account-details",
        placeholder: "请输入职务",
        valueKey: "jobTitle",
        value: null,
      },
      {
        type: "text",
        label: "地址",
        icon: "mdi-map-marker",
        placeholder: "请输入地址",
        valueKey: "address",
        value: null,
      },
      {
        type: "text",
        label: "邮编",
        icon: "mdi-barcode",
        placeholder: "请输入邮编",
        valueKey: "zip",
        value: null,
      },
      {
        type: "text",
        label: "工作电话",
        icon: "mdi-phone-classic",
        placeholder: "请输入工作电话",
        valueKey: "tel",
        value: null,
      },
      {
        type: "text",
        label: "会员证",
        icon: "mdi-book-open-outline",
        placeholder: "请输入会员证号",
        valueKey: "certNo",
        value: null,
        readonly: true,
      },
    ],
  }),
  computed: {},
  watch: {
    title(val, oldVal) {},
    formDefault: {
      handler(val, oldVal) {
        // console.log(val);
      },
      deep: true,
    },
  },
  created() {
    this.init();
    // console.log(["1","2","3"].join(","))
  },
  methods: {
    ...mapActions([
      "contentsList",
      "contentsEdit",
      "contentsCheck",
      "contentsAdd",
      "stlContents",
      "channelsGet",
      "channelsEdit",
    ]),
    init() {
      const that = this;
      this.title = this.$route.meta.title;
      var userInfo = utils.fnStorage.get("khesUserInfo");
      if (userInfo) {
        this.hasUserInfo = true;
        this.userInfo = userInfo;
        // 查询是否已有档案
        this.fnGetProfile(userInfo);
        this.fnGetOptions(config.chnProfTitle, "profTitle");
        this.fnGetOptions(config.chnProfSkill, "profSkill");
        this.fnGetOptions(config.chnEthnicGroup, "ethnicGroup");
        this.fnGetOptions(config.chnPolitics, "politics");
        this.fnGetOptions(config.chnQualification, "qualification");
        this.fnGetOptions(config.chnDegree, "degree");
      }
    },
    fnSetFormValue(obj) {
      this.formDefault.map((e, index) => {
        if (e.type == "chips" && e.multiple) {
          if (obj[e.valueKey] == "" || !obj[e.valueKey]) {
            e.value = [];
          } else {
            e.value = obj[e.valueKey].split(",");
          }
        } else {
          e.value = obj[e.valueKey];
        }
      });
    },
    fnGetProfile(userInfo) {
      const that = this;
      this.loading = true;
      var condition = [];
      var mobile;
      if (userInfo.cellPhone) {
        mobile = userInfo.cellPhone;
      } else {
        mobile = userInfo.userName;
      }
      condition = [
        {
          column: "SubTitle",
          operator: "=",
          value: mobile,
        },
        {
          column: "Author",
          operator: "=",
          value: userInfo.id,
        },
      ];
      var params = {
        data: {
          siteId: config.siteId,
          channelId: config.chnMember,
          wheres: condition,
          page: 1,
          perPage: 100,
        },
      };
      // console.log(params);
      var userProfile = sessionStorage.khesUserProfile;
      this.contentsList(params).then(async (res) => {
        var totalCount = res.data.totalCount;
        if (res.status == 200 && totalCount == 1) {
          // 已有档案记录不支持再次认领
          if (userProfile) {
            sessionStorage.removeItem("khesUserProfile");
            that.tips = true;
            that.tipsText = "您已经有档案记录，不能再次认领！";
            setTimeout(() => {
              that.tips = false;
            }, 3000);
          }
          that.currentProfile = res.data.contents[0];
          that.hasProfile = true;
          that.fnSetFormValue(that.currentProfile);
        } else if (res.status == 200 && totalCount == 0) {
          // 会员列表页半小时内点击了认领的
          if (userProfile) {
            that.tipsText = "正在匹配";
            sessionStorage.removeItem("khesUserProfile");
            that.fnClaim(JSON.parse(userProfile));
          } else {
            // 可能有的档案（与姓名模糊匹配）
            that.fnGetProfileList(userInfo);
          }
        } else {
          that.timeout = 3000;
          that.tipsText = "无关联档案";
        }
      });
    },
    fnGetProfileList(userInfo) {
      const that = this;
      this.loading = true;
      var realName;
      if (userInfo.realName) {
        realName = userInfo.realName;
      } else {
        realName = userInfo.displayName;
      }
      var condition = [
        {
          column: "Title",
          operator: "Like",
          value: `%${realName}%`,
        },
        {
          column: "Author",
          operator: "=",
          value: null,
        },
      ];
      var params = {
        data: {
          siteId: config.siteId,
          channelId: config.chnMember,
          wheres: condition,
          page: 1,
          perPage: 1000,
        },
      };
      this.contentsList(params).then(async (res) => {
        var totalCount = res.data.totalCount;
        if (res.status == 200 && totalCount > 0) {
          that.multiProfile = true;
          that.profileList = res.data.contents;
        } else {
          that.noProfile = true;
          that.timeout = 3000;
          that.tipsText = "无关联档案";
        }
      });
    },
    fnCreatProfile() {
      this.addProfile = true;
    },
    fnGetOptions(channel, column) {
      const that = this;
      this.loading = true;
      var params = {
        siteId: config.siteId,
        channelId: channel,
        scope: "all",
      };
      this.stlContents(params).then(async (res) => {
        if (res.status == 200) {
          var chips = await res.data.value.map((item) => {
            return item.title;
          });
          that.formDefault.forEach((item) => {
            if (item.type == "chips" && item.valueKey == column) {
              item.values = chips;
            }
          });
          that.loading = false;
        } else {
          that.tipsText = "未找到记录";
          setTimeout(() => {
            that.loading = false;
          }, 2000);
        }
      });
    },
    fnSetParams(mode) {
      var currentProfile;
      if (mode == "edit") {
        currentProfile = this.currentProfile;
      } else if (mode == "add") {
        currentProfile = {
          siteId: config.siteId,
          channelId: config.chnMember,
        };
      }
      this.formDefault.forEach((e) => {
        if (e.value) {
          if (e.multiple) {
            currentProfile[e.valueKey] = e.value.join(",");
          } else {
            currentProfile[e.valueKey] = e.value;
          }
        } else {
          currentProfile[e.valueKey] = "";
        }
      });
      Object.assign(currentProfile, {
        // 避免被修改为默认值
        // checked: 1,
        title: utils.setName(this.userInfo), // 标题为用户姓名
        subTitle: this.userInfo.cellPhone, // 副标题为手机号
        gender: this.userInfo.gender, // 性=-
        birthday: this.userInfo.birthday, // 出生日期
        imageUrl: this.userInfo.avatarUrl, // 用户头像
        author: this.userInfo.id, // 内容与用户ID的关联关系
      });
      var params = {
        path: {
          siteId: currentProfile.siteId,
          channelId: currentProfile.channelId,
        },
        data: currentProfile,
      };
      if (mode == "edit") {
        params.path.id = currentProfile.id;
        this.fnEditProfile(params);
      } else if (mode == "add") {
        this.fnAddProfile(params);
      }
    },
    fnEditProfile(params) {
      const that = this;
      this.loading = true;
      that.tipsText = "保存成功，待审核";
      that.timeout = 3000;
      // console.log(params)
      this.contentsEdit(params).then((res) => {
        if (res.status == 200) {
          // console.log(res);
          that.currentProfile = res.data;
          // that.fnCheck(that.currentProfile);
        }
      });
    },
    fnAddProfile(params) {
      const that = this;
      this.loading = true;
      console.log(params);
      that.tipsText = "添加成功，待审核";
      that.timeout = 3000;
      this.contentsAdd(params).then((res) => {
        if (res.status == 200) {
          console.log(res);
          that.currentProfile = res.data;
          // that.fnCheck(that.currentProfile);
        }
      });
      this.hasProfile = true;
      this.addProfile = false;
    },
    fnCheck(item) {
      const that = this;
      this.loading = true;
      var params = {
        data: {
          siteId: item.siteId,
          contents: [
            {
              channelId: item.channelId,
              id: item.id,
            },
          ],
          reasons: "终审通过",
        },
      };
      this.contentsCheck(params).then((res) => {
        that.tipsText = "审核成功";
        if (res.status == 200) {
          console.log(res);
        }
      });
    },
    fnEditOrg(id) {
      this.$router.push(`orgedit/${id}`);
    },
    fnClaim(item) {
      this.loading = true;
      var userInfo = utils.fnStorage.get("khesUserInfo");
      if (userInfo.id) {
        this.currentProfile = item;
        this.fnSetFormValue(item);
        this.tipsText = "认领成功，请保存";
        this.timeout = 3000;
        this.hasProfile = true;
        // var currentProfile = item;
        // Object.assign(currentProfile, {
        //   // 避免被修改为默认值
        //   // checked: 1,
        //   title: utils.setName(this.userInfo), // 标题为用户姓名
        //   subTitle: this.userInfo.cellPhone
        //     ? this.userInfo.cellPhone
        //     : currentProfile.subTitle, // 副标题为手机号
        //   gender: this.userInfo.gender
        //     ? this.userInfo.gender
        //     : currentProfile.gender, // 性别
        //   birthday: this.userInfo.birthday
        //     ? this.userInfo.birthday
        //     : currentProfile.birthday, // 出生日期
        //   imageUrl: this.userInfo.avatarUrl
        //     ? this.userInfo.avatarUrl
        //     : currentProfile.imageUrl, // 用户头像
        //   author: this.userInfo.id, // 内容与用户ID的关联关系
        // });
        // var params = {
        //   path: {
        //     siteId: currentProfile.siteId,
        //     channelId: currentProfile.channelId,
        //     id: currentProfile.id,
        //   },
        //   data: currentProfile,
        // };
        // this.fnEditProfile(params);
      }
    },
  },
};
</script>
